import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoNotificationService, PoTableColumn } from '@po-ui/ng-components';
import { RomaneioService } from '../service/romaneio.service';
import { environment } from 'src/environments/environment';
import { getDefaultRomaneioNF, RomaneioNF } from '../interface/romaneio';

@Component({
  selector: 'app-romaneio-nf-entrada',
  templateUrl: './romaneio-nf-entrada.component.html',
  styleUrl: './romaneio-nf-entrada.component.css'
})
export class RomaneioNfEntradaComponent implements OnInit {

  urlApiProtheus: string = environment.urlApiProtheus;
  CDOCSERIE: string = "";
  romaneioNF: RomaneioNF = getDefaultRomaneioNF();

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Pré-cadastro Cliente'},
    ],
  };

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poNotificationService: PoNotificationService,
  ) {

  }

  ngOnInit(): void {

  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  escolheNota(): void {
    let aNota = this.CDOCSERIE.split("/");
    this.romaneioService.getNFEntrada(aNota[0], aNota[1], aNota[2], aNota[3]).subscribe((ret) => {
      this.romaneioNF = ret;

      if (this.romaneioNF.items.filter((item) => (item.CD1LOTECTL == '' || item.NB8SALDO == 0)).length > 0){
        this.poNotificationService.warning("Esta NF possui itens com saldo zerado e/ou lote em branco. Esses itens não serão adicionados ao romaneio.")
      }
    });
  }
  
  public readonly  colunasItems: Array<PoTableColumn> = [
    {property: 'CD1COD',      label: 'Produto'            , type: 'string'     , width: '15%'},
    {property: 'CB1DESC',     label: 'Descrição'          , type: 'string'     , width: '30%'},
    {property: 'CD1UM',       label: 'UM'                 , type: 'string'     , width: '5%'},
    {property: 'ND1QUANT',    label: 'Quantidade'         , type: 'number'     , width: '10%'},
    {property: 'ND1VUNIT',    label: 'V. Unit.'           , type: 'number'     , width: '10%'},
    {property: 'ND1TOTAL',    label: 'V. Total'           , type: 'number'     , width: '10%'},
    {property: 'CD1LOTECTL',  label: 'Lote'               , type: 'string'     , width: '10%'},
    {property: 'NB8SALDO',    label: 'Saldo'              , type: 'number'     , width: '10%'},
  ];

  gerarRomaneio(): void {
    this.romaneioService.postGerarRomaneioNFE(this.romaneioNF).subscribe((ret) => {
      this.poNotificationService.success("O romaneio "+ret.CZ00COD+" foi criado.");
      this.CDOCSERIE = '';
      this.romaneioNF = getDefaultRomaneioNF();
    })
  }

}
